import { CREATE_WATCH_LIST_ENTRY } from '../types';
import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  createWatchListEntry,
  createWatchListEntryPending,
  createWatchListEntryFulfilled,
  createWatchListEntryRejected,
} = createAsyncActions(CREATE_WATCH_LIST_ENTRY, 'createWatchListEntry');


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/actions/createWatchListEntryActions.js